@if (cofaceForm) {
  <form
    class="wrapper"
    [formGroup]="cofaceForm"
  >
    <div class="coface-form-header">
      <h1>{{ "CASE_FORM.FORMS.SUMMARY.COFACE_FORM_TITLE" | translate }}</h1>
      <button
        payee-button
        color="white"
        type="button"
        width="auto"
        [isBorderButton]="true"
        (click)="goToClaimEditor()"
      >
        {{ "CASE_FORM.FORMS.SUMMARY.COFACE_EDIT_CLAIMS_BUTTON" | translate }}
      </button>
    </div>
    @for (claimForm of claims.controls; track claimForm; let i = $index) {
      <form
        class="coface-claim-card"
        [formGroup]="$any(claimForm)"
      >
        <div class="coface-claim-header flex vcenter">
          <span class="coface-claim-badge">{{ i + 1 }}</span>
          <span class="coface-claim-amount">
            {{ summary.claims[i].original_amount | number: "1.0" : "hu" }}
            {{ summary.claims[i].currency_iso }}
          </span>
          <span class="coface-claim-due grow1">
            {{ "CASE_FORM.FORMS.SUMMARY.COFACE_CLAIM_DUE_LABEL" | translate }}
            {{ summary.claims[i].due_date_at | date: "yyyy.MM.dd." }}
          </span>
        </div>
        <div class="coface-file-row">
          <payee-icon
            name="upload-paper"
            width="16"
            height="16"
          ></payee-icon>
          @if (claimForm.value.file) {
            @if (claimFileIsUploaded(claimForm)) {
              <a
                class="coface-file-name coface-file-link"
                target="_blank"
                rel="noopener"
                [href]="getClaimFileStorageUrl(claimForm)"
              >
                {{ getClaimFileName(claimForm) }}
              </a>
            } @else {
              <a
                class="coface-file-name coface-file-link"
                href="#"
                role="button"
                (click)="openLocalClaimFile(claimForm); $event.preventDefault()"
                (keydown.enter)="openLocalClaimFile(claimForm); $event.preventDefault()"
              >
                {{ getClaimFileName(claimForm) }}
              </a>
            }
            <label class="coface-upload-label coface-reupload-label">
              <input
                type="file"
                accept=".pdf,.jpg,.jpeg,.png"
                class="coface-file-input"
                (change)="onCofaceFileSelected(claimForm, $event)"
              />
              <payee-icon
                name="pencil"
                width="14"
                height="14"
              ></payee-icon>
            </label>
          } @else {
            <label class="coface-upload-label">
              <input
                type="file"
                accept=".pdf,.jpg,.jpeg,.png"
                class="coface-file-input"
                (change)="onCofaceFileSelected(claimForm, $event)"
              />
              <span class="coface-file-missing-text">
                {{ "CASE_FORM.FORMS.SUMMARY.COFACE_CLAIM_FILE_MISSING" | translate }}
              </span>
            </label>
          }
        </div>
        <div>
          <span class="coface-field-label">
            {{ "CASE_FORM.FORMS.SUMMARY.COFACE_INVOICE_TYPE_LABEL" | translate }}
          </span>
          <mat-radio-group
            formControlName="coface_invoice_type_code"
            class="coface-invoice-type-group flex alt-theme"
            color="primary"
          >
            @for (invoice_type of summary.coface_invoice_types; track invoice_type.code) {
              <mat-radio-button [value]="invoice_type.code">
                {{ invoice_type.label }}
              </mat-radio-button>
            }
          </mat-radio-group>
          @if (claimForm.get("coface_invoice_type_code")?.invalid && claimForm.get("coface_invoice_type_code")?.dirty) {
            <mat-error>
              {{ "ERROR_MESSAGES.FIELD_REQUIRED" | translate }}
            </mat-error>
          }
        </div>
        <payee-form-field
          width="max"
          height="tall"
        >
          <span payee-label>
            {{ "CASE_FORM.FORMS.SUMMARY.COFACE_INVOICE_DATE_LABEL" | translate }}
          </span>
          <payee-datepicker
            formControlName="issued_at"
            [placeholder]="'CASE_FORM.FORMS.SUMMARY.COFACE_INVOICE_DATE_PLACEHOLDER' | translate"
            [max]="getCofaceClaimMaxInvoiceDate(i)"
          ></payee-datepicker>
          @if (claimForm.get("issued_at")?.invalid && claimForm.get("issued_at")?.dirty) {
            <ng-container payee-error>
              @if (claimForm.get("issued_at")?.hasError("required")) {
                <span>
                  {{ "ERROR_MESSAGES.FIELD_REQUIRED" | translate }}
                </span>
              }
              @if (claimForm.get("issued_at")?.hasError("beforeDueDate")) {
                <span>
                  {{ "CASE_FORM.FORMS.SUMMARY.COFACE_INVOICE_DATE_BEFORE_DUE_DATE" | translate }}
                </span>
              }
            </ng-container>
          }
        </payee-form-field>
      </form>
    }
    <div class="coface-terms">
      <mat-checkbox [formControl]="terms_accepted">
        <div class="coface-terms-label">
          <span>{{ "CASE_FORM.FORMS.SUMMARY.COFACE_TERMS_TEXT_PART_1" | translate }}</span>
          <a
            target="_blank"
            href="assets/coface/terms.pdf"
          >
            {{ "CASE_FORM.FORMS.SUMMARY.COFACE_TERMS_LINK" | translate }}
          </a>
          <span>{{ "CASE_FORM.FORMS.SUMMARY.COFACE_TERMS_TEXT_PART_2" | translate }}</span>
        </div>
      </mat-checkbox>
      @if (terms_accepted.invalid && terms_accepted.dirty) {
        <mat-error>
          {{ "CASE_FORM.FORMS.SUMMARY.COFACE_TERMS_ERROR" | translate }}
        </mat-error>
      }
      @if (termsAcceptedAt) {
        <span class="coface-terms-accepted-at">
          {{ "CASE_FORM.FORMS.SUMMARY.COFACE_TERMS_ACCEPTED_AT" | translate: { date: termsAcceptedAt | date: "yyyy.MM.dd." } }}
        </span>
      }
    </div>
  </form>
}
